import { eDashboardActionIds } from "../../action-types/dashboard/IDashboardActions";
import { dashboardApi } from "../../../api/dashboard/dashboardApi";
import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";

export function* dashboardSaga() {
    yield takeLatest(eDashboardActionIds.LOAD_START, loadDashboardWorker);
}

export function* loadDashboardWorker() {
    const response: IBaseResponse = yield call(dashboardApi.SelectDashboard);
    if (response.is_success) {
        yield put(rootActions.dashboard.LOAD_SUCCESS(response.data));
    } else {
        yield put(rootActions.dashboard.LOAD_ERROR(response.message ?? "Có lỗi"));
    }
}